import { api } from "../../config";

export const getReport = async (token: string, query: any) => {
    const response = await api(token).post("/tickets/reports", query)
    return response
}